module.exports = __webpack_public_path__ + "static/media/personne-malentendante-solution.31ecc3ac.png";